import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { HomeOutlined, AppstoreOutlined, CalendarOutlined, UserOutlined, LoginOutlined, TeamOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import { useTheme } from '../components/ParticleBackground';
import { useAuth } from '../contexts/AuthContext';

const MobileBottomNav = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { getThemeStyles } = useTheme();
    const themeStyles = getThemeStyles();
    const { user } = useAuth();

    const navItems = [
        {
            label: 'Home',
            icon: <HomeOutlined />,
            path: '/'
        },
        {
            label: 'About',
            icon: <TeamOutlined />,
            path: '/about'
        },
        {
            label: 'Services',
            icon: <AppstoreOutlined />,
            path: '/services'
        },
        {
            label: 'Bookings',
            icon: <CalendarOutlined />,
            path: '/my-bookings'
        },
        {
            label: user ? 'Profile' : 'Sign In',
            icon: user ? (
                <Avatar
                    src={user.photoURL}
                    size={24}
                    style={{
                        backgroundColor: user.photoURL ? 'transparent' : themeStyles.accentPrimary,
                        color: '#fff',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    icon={!user.photoURL && !user.name && !user.email ? <UserOutlined /> : null}
                >
                    {!user.photoURL && (user.name || user.email || 'U').charAt(0).toUpperCase()}
                </Avatar>
            ) : <LoginOutlined />,
            path: user ? '/profile' : '/signin'
        }
    ];

    return (
        <div style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            height: '64px',
            background: themeStyles.cardBg,
            borderTop: `1px solid ${themeStyles.cardBorder}`,
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            zIndex: 1000,
            paddingBottom: 'safe-area-inset-bottom',
            backdropFilter: 'blur(20px)',
            boxShadow: '0 -4px 20px rgba(0,0,0,0.05)'
        }}>
            {navItems.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                    <div
                        key={item.label}
                        onClick={() => navigate(item.path)}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flex: 1,
                            height: '100%',
                            cursor: 'pointer',
                            color: isActive ? themeStyles.accentPrimary : themeStyles.textSecondary,
                            transition: 'all 0.3s ease'
                        }}
                    >
                        <div style={{
                            fontSize: '24px',
                            marginBottom: '4px',
                            transform: isActive ? 'scale(1.1)' : 'scale(1)',
                            transition: 'all 0.3s ease',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            {item.icon}
                        </div>
                        <span style={{
                            fontSize: '10px',
                            fontWeight: isActive ? '600' : '400'
                        }}>
                            {item.label}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default MobileBottomNav;
